import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { breakPoints, colors, measurments } from "../utils/config";
import { fetcher } from "../utils/fetcher";
import Card from "../sharedUI/Card";
import Button from "../sharedUI/Button";
import Input from "../sharedUI/Input";

const StyledLogin = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  .logo-container{
    position: absolute;
    top: 1rem;
    left: 1rem;
  }
  .logo {
    width: 200px;
  }
  .form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    form {
      width: 400px;
      max-width: 100%;
    }
  }
  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    flex-grow: 1;
  }
  .image-container {
    border-radius: ${measurments.borderRadius}px 0 0
      ${measurments.borderRadius}px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colors.primary.pressed};
    img{
      width: 90px;
    }
  }
  .logo-mobile {
    display: none;
  }
  ${breakPoints.tablet} {
    padding: 1rem;
    .image-container {
      display: none;
    }
    .two-col {
      grid-template-columns: 1fr;
    }
    .container-fw {
      padding: 0;
    }
    .form-container {
      width: 100%;
      .form-wrap {
        width: 100%;
      }
      form {
        width: 100%;
      }
    }
    .logo {
      display: none;
    }
    .logo-mobile {
      display: block;
      width: 24px;
    }
  }s
`;

const Login = ({ login, globalState, setGlobalState, notify }) => {
  const navigate = useNavigate();

  //States
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  //Functions
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    login(
      formData,
      (data) => {
        notify.success(`Välkommen ${data.user.firstName}!`);
      },
      (error) => {
        setLoading(false);
        notify.error(error);
      }
    );
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const verifyToken = async (token) => {
    const { err, data } = await fetcher({
      path: "admin-auth/verify-token",
      auth: token,
    });
    if (err) return false;
    else return data;
  };

  const checkUser = async () => {
    const storedToken = localStorage.getItem("bg-kurswebb-admin-token");
    if (globalState.user) navigate("/", { replace: true });
    else if (storedToken) {
      setGlobalState({
        ...globalState,
        appLoading: true,
      });

      const user = await verifyToken(storedToken);
      if (!user) {
        localStorage.removeItem("bg-kurswebb-admin-token");
        setGlobalState({
          ...globalState,
          appLoading: false,
        });
        return;
      }
      setGlobalState({
        ...globalState,
        user,
        token: storedToken,
      });
    } else localStorage.removeItem("bg-kurswebb-admin-token");
  };

  useEffect(() => {
    checkUser();
    //eslint-disable-next-line
  }, [globalState.user]);

  return (
    <StyledLogin>
      <div className="logo-container">
        <img
          src="/images/logo-horizontal.png"
          alt="Brommagymnasterna"
          className="logo"
        />
        <img
          src="/images/logo-symbol.png"
          alt="Brommagymnasterna"
          className="logo-mobile"
        />
      </div>
      <div className="two-col">
        <div className="image-container">
          <img src="/images/symbol-color.png" alt="" />
        </div>
        <div className="form-container">
          <div className="form-wrap">
            <p className="m0 b1">Admin</p>
            <h1 className="h1 m0 mbottom1">Tränarportalen</h1>
            <Card>
              <p className="h3 m0 mbottom1">Logga in som administratör</p>
              <form onSubmit={handleSubmit}>
                <Input
                  type="email"
                  value={formData.email}
                  name="email"
                  disabled={loading}
                  onChange={handleChange}
                  placeholder="din.epost@mail.se"
                  label="Mailadress"
                />
                <Input
                  type="password"
                  value={formData.password}
                  name="password"
                  disabled={loading}
                  onChange={handleChange}
                  label="Lösenord"
                />
                <div className="flex mtop2">
                  <Button
                    className="b2"
                    type="submit"
                    disabled={loading}
                    btnType="primary"
                  >
                    {loading ? "Loggar in..." : "Logga in"}
                  </Button>
                  {/* <Link to="/glomt-losenord">
                    <Button
                      type="button"
                      disabled={loading}
                      btnType="neutral"
                      className="b2 mleft1"
                    >
                      Glömt lösenord?
                    </Button>
                  </Link> */}
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </StyledLogin>
  );
};

export default Login;
